module.exports = __webpack_public_path__ + "img/sanya2021.06.d8d63cf6.png";